import { render, staticRenderFns } from "./editGateway.vue?vue&type=template&id=4ad195ad"
import script from "./editGateway.vue?vue&type=script&lang=js"
export * from "./editGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports